<div class="video-container">
  @if (call.videoUrl !== null) {
    <vg-player (onPlayerReady)="onPlayerReady($event)">
      <video #media [vgMedia]="$any(media)" id="video" preload="auto" (click)="togglePlay()" (contextmenu)="$event.preventDefault()" [controls]="isFullScreen">
        <source [src]="call.videoUrl" type="video/mp4" />
      </video>
    </vg-player>
    <app-media-player-controller
      [currentTime]="getTime()"
      [duration]="getDuration()"
      [isPlaying]="isPlaying"
      [allowDownload]="allowDownload"
      [displaySpeakerLabelingModeButton]="displaySpeakerLabelingModeButton"
      [pauseIntervals]="call.pauseIntervals"
      (play)="play()"
      (pause)="pause()"
      (seek)="seek($event)"
      (changePlaybackRate)="changePlaybackRate($event)"
      (changeVolume)="changeVolume($event)"
      (jumpToNextSpeaker)="handleJumpToNextSpeaker()"
      (toggleFullscreen)="toggleFullscreen()"
      (download)="download()"
    ></app-media-player-controller>
  }
</div>
